import { useRef } from "react";

export function useAbortController() {
  const controllerRef = useRef<AbortController | null>(null);

  const createController = () => {
    // Abort any existing controller before creating a new one
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    controllerRef.current = new AbortController();
    return controllerRef.current;
  };

  const abort = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
  };

  const cleanup = () => {
    controllerRef.current = null;
  };

  const getSignal = () => {
    return controllerRef.current?.signal;
  };

  return { createController, abort, cleanup, getSignal };
}
